import {Dropdown} from "../../../styleguide/js/components/dropdown/dropdown";

window.pew.addRegistryEntry({key: 'wdf-dropdown', domSelector: '.wdf-dropdown', classDef: Dropdown});